import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _listAppPlansByAppIdRequest = {};
var _listAppPlansByAppIdResponse = {};
function resolveWixAppmarketAppPlansV1AppsPlansUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/apps-plans',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/app-market/apps-plans',
                destPath: '/api',
            },
            {
                srcPath: '/api/apps-plans',
                destPath: '',
            },
            {
                srcPath: '/apps-plans',
                destPath: '',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/_api/apps-plans',
                destPath: '',
            },
            {
                srcPath: '/apps-plans',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_api/apps-plans',
                destPath: '',
            },
            {
                srcPath: '/apps-plans',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/apps-plans',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/apps-plans',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/apps-plans',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/apps-plans',
                destPath: '',
            },
            {
                srcPath: '/_api/apps-plans',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/apps-plans',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Retrieves plans for the given apps.
 *
 *
 * Also returns tax settings and currency details. Wix calculates this information
 * based on the 2-letter country code in [ISO-3166 alpha-2](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2#Officially_assigned_code_elements)
 * format that you pass in the call's header. If you don't pass a country code in
 * the header, Wix calculates the tax settings and currency details based on the
 * call's IP address. Note that the tax settings and currency details may not resolve
 * properly if you call through a VPN.
 *
 * Prices for plans that are managed outside of Wix aren't returned.
 *
 * Consumers must pay for yearly and multi-yearly plans of your app every month.
 * For these plans this endpoint returns the price that the consumer must pay every
 * month and not the total price for the entire year.
 *
 * <blockquote class="important">
 *
 * __Important:__
 * The App Plans API doesn't follow any tenancy model. You don't need any
 * permissions to call `List App Plans by App ID`.
 *
 * </blockquote>
 */
export function listAppPlansByAppId(payload) {
    var _a = serializer(_listAppPlansByAppIdRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listAppPlansByAppIdResponse, {}).fromJSON;
    function __listAppPlansByAppId(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.appmarket.v1.app_plans',
            method: 'GET',
            methodFqn: 'wix.appmarket.app_plans.v1.AppsPlans.ListAppPlansByAppId',
            url: resolveWixAppmarketAppPlansV1AppsPlansUrl({
                protoPath: '/v1/apps-plans/{appIds}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listAppPlansByAppId.fromReq = fromReq;
    __listAppPlansByAppId.__isAmbassador = true;
    return __listAppPlansByAppId;
}
//# sourceMappingURL=http.impl.js.map